import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import strings from "./utils/strings";
import { useIsAuthenticated } from "@azure/msal-react";
import authService from "./services/authService";
import { useDispatch, useSelector } from "react-redux";
import { getAdminPrivilege } from "./modules/notification/notificationThunk";
import { resetGetAdminPrivilege } from "./modules/notification/notificationSlice";

const PublicRoute = ({ element: Component, ...rest }) => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const location = useLocation;
  const isAuthenticated = useIsAuthenticated();
  const { getAdminPrivilegeSuccess } = useSelector((state) => state.notification);
  const [privilege, setPrivilege] = useState(null);

  useEffect(() => {
    if (getAdminPrivilegeSuccess && getAdminPrivilegeSuccess.status === "success") {
      authService.setPrivilege(getAdminPrivilegeSuccess.data);
      setPrivilege(getAdminPrivilegeSuccess.data)
    }
    dispatch(resetGetAdminPrivilege());
  }, [getAdminPrivilegeSuccess]);

  const newData = authService.getPrivilege();

  useEffect(() => {
    setPrivilege(newData);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getAdminPrivilege());
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (privilege && isAuthenticated) {
      switch (true) {
        case privilege.hasPatientProfileRight:
          nav(strings.navigation.patientProfile);
          break;
        case privilege.hasDepartmentRight:
          nav(strings.navigation.department);
          break;
        case privilege.hasHomeCareRight:
          nav(strings.navigation.manageNurseReq);
          break;  
        case privilege.hasNationalIdRight:
          nav(strings.navigation.nationalID);
          break;
        case privilege.hasTNCright:
          nav(strings.navigation.termsCondition);
          break;
        case privilege.hasArticleRight:
          nav(strings.navigation.healthArticle);
          break;
      }
    }
  }, [privilege, isAuthenticated]);

    console.log("public")



  // return !isAuthenticated ? <Component {...rest} /> : <Navigate to={location.state?.from} />;
  return <Component {...rest} />;
};

export default PublicRoute;
